/* Mobile sticky buy bar: mirrors the real add-to-cart button, shows only when it scrolls out of view. */
(function () {
  if (!window.matchMedia('(max-width: 989px)').matches) return;
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('.product__info-container .product-form__submit');
    var priceEl = document.querySelector('.product__info-container .price__container .price-item--regular');
    var titleEl = document.querySelector('.product__title h1');
    if (!form || !titleEl) return;
    var bar = document.createElement('div');
    bar.className = 'nc-buybar';
    bar.innerHTML =
      '<div class="nc-buybar__info"><span class="nc-buybar__title"></span><span class="nc-buybar__price"></span></div>' +
      '<button type="button" class="nc-buybar__btn button"></button>';
    document.body.appendChild(bar);
    var t = bar.querySelector('.nc-buybar__title');
    var p = bar.querySelector('.nc-buybar__price');
    var b = bar.querySelector('.nc-buybar__btn');
    t.textContent = titleEl.textContent.trim();
    function sync() {
      var live = document.querySelector('.product__info-container .product-form__submit');
      var livePrice = document.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
      if (livePrice) p.textContent = livePrice.textContent.trim();
      if (live) {
        b.textContent = live.textContent.trim();
        b.disabled = live.disabled;
      }
    }
    sync();
    b.addEventListener('click', function () {
      var live = document.querySelector('.product__info-container .product-form__submit');
      if (live) live.click();
    });
    document.addEventListener('change', sync);
    document.addEventListener('variant:change', sync);
    var ticking = false;
    function check() {
      ticking = false;
      var live = document.querySelector('.product__info-container .product-form__submit');
      if (!live) return;
      var r = live.getBoundingClientRect();
      var footer = document.querySelector('.footer');
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
      bar.classList.toggle('is-visible', r.bottom < 0 && !nearFooter);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  });
})();
